import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { sync } from '@app/icare/client/sync'
import { PatientFormId } from '@app/icare/db/schema/form/PatientFormCommon'
import { PatientMasterDataSheetSchema } from '@app/icare/db/schema/form/PatientMasterDataSheet'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { appFormOptions } from '@app/icare/form/appFormOptions'
import { useAppForm } from '@app/icare/form/useAppForm'
import { zodParams } from '@pkg/db/utils'
import { formSchemaOptions } from '@pkg/form/utils/form.utils'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { toast } from 'react-hot-toast/headless'
import { z } from 'zod'
import { EditMasterDataSheet } from './-edit'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/stammblatt/$form/')({
  component: RouteComponent,
  params: zodParams(z.object({ id: PatientId.ref, form: PatientFormId.ref })),
  loader: async ({ params, context: { queryClient } }) => {
    await queryClient.ensureQueryData(localQueryEntityOptions(params.form))
  },
  staticData: {
    layout: {
      menuRender: false,
    },
  },
})

function RouteComponent() {
  const { form: formId } = Route.useParams()

  const current = useQuery(localQueryEntityOptions(formId))

  const form = useAppForm(
    appFormOptions(PatientMasterDataSheetSchema, {
      defaultValues: current.data,
      onSubmit: ({ value }) => sync.mutate(value),
    }),
  )

  return (
    <form.AppForm>
      <form.ProForm>
        <EditMasterDataSheet />
      </form.ProForm>
    </form.AppForm>
  )
}
